import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
export function App() {
  useEffect(() => {
    document.title = 'METODO BARBER PRO';
  }, []);
  return <LandingPage data-id="element-0" />;
}